import React from 'react';
import { withRouter } from 'react-router-dom';

import { translate } from 'components/translate';
import { GROUPS, NAMES } from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { ACTIONS, CATEGORIES, EVENTS } from 'modules/app/services/ga/constants';
import clubSales from 'modules/dashboard/assets/club-sales.svg';
import { MembershipStore } from 'modules/membership';
import PropTypes from 'prop-types';

import NavigationCard from './NavigationCard';

const ClubSalesNavigationCard = ({ t, history }) => {
  const registerMetrics = () => {
    const { marketplaceId } = MembershipStore;

    if (marketplaceId) {
      const DATAHUB_EVENT = {
        group: GROUPS.PLUS_ACCESS,
        name: NAMES.CARD_MAKE_SALES,
        user: { id: marketplaceId }
      };

      const GTM_EVENT = {
        event: EVENTS.INTERACTION,
        event_category: CATEGORIES.CLUB_ADMIN_CONTENT,
        event_action: ACTIONS.PLUS_ACCESS.CLICK_SALES_CARD,
        event_label: true
      };

      try {
        window.dataLayer.push(GTM_EVENT);
        DatahubService.sendMetrify(DATAHUB_EVENT);
      } catch {
        // do nothing
      }
    }
  };

  const onClick = () => {
    registerMetrics();
    history.push('/modules');
  };

  return (
    <NavigationCard
      image={clubSales}
      title={t('dashboard.navigation_card.club_sales.title')}
      description={t('dashboard.navigation_card.club_sales.description')}
      onClick={onClick}
    />
  );
};

ClubSalesNavigationCard.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default translate()(withRouter(ClubSalesNavigationCard));
